import React, {Component} from 'react';
import {Container, Loader, Form, Grid, Segment} from 'semantic-ui-react';
import {connect} from 'react-redux';
import _ from 'lodash';
import ApiActions from 'go/actions/api';
import {
  API_CONFIG_GET_SUCCESS,
  API_ORG_GET_BY_USER_SUCCESS,
  API_ORG_GET_BY_ID_SUCCESS,
  API_ORGS_LIST_GET_BY_ID_SUCCESS,
  API_DYNAMIC_DATA_GRANT_BY_ORGANIZATION_GET_SUCCESS,
  API_DYNAMIC_DATA_GRANT_BY_ORGANIZATION_GET_FAILURE,
  DYNAMIC_DATA_GET_ORG_ENTITY_SUCCESS,
  DYNAMIC_DATA_GET_ORG_ENTITY_FAILURE,
} from 'common/types';
import {
  ASSOCIATED_ENTITY_STATUSES,
  ENTITY_MAP,
  ORG_REL_TYPE_MAP,
} from 'app-ui-componentlibrary/dist/common/constants';
import {GRANT_WRITER_ROLE} from 'go/components/organization/team/constants';
import Main from 'app-ui-componentlibrary/dist/go/components/layout/main';
import {Alert} from 'componentLibrary';
import Error from 'app-ui-componentlibrary/dist/go/components/common/error';
import GrantsFilterResults from './GrantsFilterResults';
import REST from 'go/requests/rest';
import {Toggle} from 'componentLibrary';
import {ROLE_MAP} from 'app-ui-componentlibrary/dist/common/constants';
import {
  TextBoxField,
  InlineSelect,
  Select,
  RadioField,
  Checkbox,
} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import PermissionsUtility from 'go/security/permissionsUtility';
import DynamicComponentActions from 'go/actions/dynamicComponent';
import {GRANT_MANAGE_PAGE} from 'app-ui-componentlibrary/dist/go/components/common/pageTitles';
import {
  getUniqs,
  toStartCase,
  subApplicationsToSubGrantsFilter,
  filterByEntityType,
} from 'common/utils';
import {forceJsonResponse, MONO, FLUX} from 'common/utils';

const DEFAULT_FILTERS = [
  {filter: 'sortBy', value: 'fiscalYr'},
  {filter: 'sortDir', value: 'ASC'},
];

const EMPTY_FILTER = [{key: '', value: null, text: ''}];
const SEARCH_OPTIONS = {
  INITIAL: 'start',
  IN_PROGRESS: 'inprogress',
  SUCCESS: 'success',
  ERROR: 'error',
  DEFAULT: 'title',
};
export class _Grants extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allOrgs: [],
      loading: true,
      error: false,
      configName: 'grantsConfig',
      grantConfigs: {},
      subGrantConfigs: {},
      grants: [],
      filters: {},
      sortOptions: {sortBy: '', sortDir: ''}, // Default sort
      noOrgsFound: false,
      currentOrg: {},
      orgChanged: true,
      orgPrograms: null,
      grantsChecked: false,
      projectsChecked: false,
      grantWriterEntityIds: [],
      filterKey: '',
      filterValue: '',
      subappSearchString: '',
      retrievedFilters: {},
      retrievedSortOptions: {},
      foData: [],
      amendments: [],
    };
  }

  componentDidMount() {
    document.title = GRANT_MANAGE_PAGE;
    const {token, id} = this.props;

    const permissionData = new PermissionsUtility(token);
    const {permissions} = permissionData;
    const grantWriterEntityIds = [];

    const filtersRetrieved = JSON.parse(localStorage.getItem('grantsFilters'));
    const sortOptionsRetrieved = JSON.parse(localStorage.getItem('grantsSort'));

    if (sortOptionsRetrieved) {
      if (sortOptionsRetrieved.userId !== id) {
        localStorage.setItem('grantsSort', JSON.stringify({}));
      } else {
        this.setState({
          retrievedSortOptions: sortOptionsRetrieved,
        });
      }
    }

    if (filtersRetrieved) {
      if (filtersRetrieved.userId !== id) {
        localStorage.setItem('grantsFilters', JSON.stringify({}));
      } else {
        this.setState({
          retrievedFilters: filtersRetrieved,
        });
      }
    }

    this.initializeReduxState();

    permissions.sort().forEach((org) => {
      const [orgIdentifier, roleId] = org.split(':');

      if (parseInt(roleId) === GRANT_WRITER_ROLE) {
        const [orgId, programId, subOrgId] = orgIdentifier.split('_');
        grantWriterEntityIds.push({
          hideOrgId: orgId,
          hideProgramId: programId,
          hideSubOrgId: subOrgId,
        });
      }
    });
    this.setState({grantWriterEntityIds: grantWriterEntityIds});
    if (_.includes(this.props.toggles, 'manageTeamOrgSubOrg')) {
      this.getUserEntities();
    } else {
      this.initializeWithOrgs();
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (state.loading && state.initialized) {
      return {
        ...state,
        loading: false,
      };
    }
    return null;
  }

  initializeReduxState = () => {
    const {init, auth, toggles, profile} = this.props;

    init({
      config: {},
      data: {},
      context: {
        auth,
        toggles,
        profile,
      },
      submit: {},
      validations: {},
    });
    this.setState({initialized: true});
  };

  _getConfigByCategoryId = (items) => {
    // new function because something behind a toggle uses the old one
    var cloneConfigs = _.clone(this.state.subGrantConfigs);
    let promises = [];
    var config = _.map(items, (item) => {
      const {foId, entityType, configName} = item;
      if (!cloneConfigs[foId]) {
        promises.push(
          new Promise((resolve, reject) => {
            this.props
              .getConfig(
                this.props.token,
                entityType,
                foId,
                'objectDefinition',
                configName
              )
              .then((res) => {
                if (res && res.type === API_CONFIG_GET_SUCCESS) {
                  cloneConfigs[foId] = res.payload;
                  this.setState({subGrantConfigs: cloneConfigs});
                }
                return resolve();
              });
          })
        );
      }
    });
    return Promise.all(promises);
  };

  getConfig = (foIds, entityType) => {
    var configsClone = _.clone(this.state.grantConfigs);
    let promises = [];
    var config = _.map(foIds, (foId) => {
      if (!configsClone[foId]) {
        promises.push(
          new Promise((resolve, reject) => {
            this.props
              .getConfig(
                this.props.token,
                entityType,
                foId,
                'objectDefinition',
                'grantsConfig'
              )
              .then((res) => {
                if (res && res.type === API_CONFIG_GET_SUCCESS) {
                  configsClone[foId] = res.payload;
                  this.setState({grantConfigs: configsClone});
                }
                return resolve();
              });
          })
        );
      }
    });
    return Promise.all(promises);
  };

  initializeWithOrgs = () => {
    this.props
      .getOrganizations(this.props.token)
      .then((res) => {
        if (res && res.type === API_ORG_GET_BY_USER_SUCCESS) {
          if (res.payload.length) {
            let sortedRes = _.head(_.sortBy(res.payload, 'displayName'));
            this.setState({
              allOrgs: res.payload,
              currentOrg: sortedRes,
              noOrgsFound: false,
              error: false,
            });
          } else {
            this.setState({
              noOrgsFound: true,
            });
          }
        } else {
          this.setState({
            noOrgsFound: true,
          });
        }
        return res;
      })
      .then((res) => {
        this.getCurrentOrgAndGrants(this.state.currentOrg.entityId, DEFAULT_FILTERS);
      })
      .catch((err) => {
        console.error('error');
        this.setState({
          loading: false,
          error: true,
        });
      });
  };

  getUserEntities = () => {
    this.setState({loading: true}, () => {
      REST.user
        .getEntities(this.props.token)
        .then(REST.handler.handleResponse)
        .then((response) => {
          let filteredEntities = filterByEntityType(
            response,
            parseInt(ENTITY_MAP.PANEL_REVIEW.code)
          );
          if (response) {
            const sortedRes = _.head(_.sortBy(filteredEntities, 'displayName'));
            this.setState({
              userEntities: response,
              loading: false,
              suborgsAllowed: true,
              isSuborgLoaded: true,
              allOrgs: filteredEntities,
              currentOrg: sortedRes ? sortedRes : {},
              noOrgsFound: false,
              error: false,
            });
          } else {
            this.setState({
              error: true,
              loading: false,
            });
          }
        })
        .then(() => {
          this.fetchData();
        })
        .catch(() => {
          this.setState({
            loading: false,
            error: true,
          });
        });
    });
  };

  getAmendments = (grant, foData) => {
    const grantFoData = _.find(foData, {
      fundingOpportunityId: _.toNumber(grant.fundingOpportunityId),
    });
    const bsirReporting = _.get(grantFoData, 'configData.reporting.bsirReporting', false);
    if (bsirReporting) {
      REST.dynamicData
        .getAllByGrantIdAndEntityType(this.props.token, grant.grantId, 'amendment')
        .then(REST.handler.handleResponse)
        .then((response) => {
          this.setState({
            amendments: _.concat(this.state.amendments, response),
          });
        })
        .catch((err) => {
          console.error('error fetching amendments for grant');
        });
    }
  };

  getCurrentOrgAndGrants = (entityId, orgChanged = false) => {
    if (entityId) {
      if (_.includes(this.props.toggles, 'manageTeamOrgSubOrg')) {
        _.forEach(this.state.userEntities, (entity) => {
          if (_.get(entity, 'entityId') == entityId) {
            this.setState(
              {
                currentOrg: entity ? entity : {},
              },
              () => this.fetchData(entityId, orgChanged)
            );
          }
        });
      } else {
        this.props
          .getOrganizationById(this.props.token, entityId)
          .then((res) => {
            if (res.type === API_ORG_GET_BY_ID_SUCCESS) {
              this.setState({
                currentOrg: {
                  entityId: res.payload.organizationId,
                  displayName: res.payload.displayName,
                },
              });
              this.fetchData();
            }
          })
          .catch((err) => {
            console.error('error fetching current org ');
          });
      }
    }
  };

  getApplicationExtensions = (foIds) => {
    let promises = [];
    _.each(foIds, (foId) => {
      promises.push(
        new Promise((resolve, reject) => {
          REST.fundingOpportunity
            .getFundingOpportunitiesAppExtensionsForFO(this.props.token, foId)
            .then(REST.handler.handleResponse)
            .then((foAppExtRes) => {
              if (foAppExtRes) {
                this.setState({
                  grantAppExtensions: _.compact(
                    _.concat(this.state.grantAppExtensions, foAppExtRes)
                  ),
                });
                return resolve();
              }
            })
            .catch((err) => {
              console.error('Request for application data failed.');
              return reject();
            });
        })
      );
    });
    return Promise.all(promises);
  };

  handleOrgChange = (e) => {
    this.setState({
      orgChanged: true,
      loading: true,
      grantsChecked: false,
      projectsChecked: false,
    });
    this.getCurrentOrgAndGrants(e.target.value, true);
  };

  createFilterOptions = (foIds) => {
    let filterOptions = {
      fiscalYears: _.clone(EMPTY_FILTER),
      programs: _.clone(EMPTY_FILTER),
      fundingOpportunities: _.clone(EMPTY_FILTER),
      status: _.clone(EMPTY_FILTER),
    };

    return Promise.all(
      _.map(foIds, (foId) => {
        return REST.fundingOpportunity.getFundingOpportunity(this.props.token, foId);
      })
    )
      .then((res) =>
        Promise.all(
          _.map(res, (fo) => {
            return fo.json();
          })
        )
      )
      .then((fundingOpportunityData) => {
        // mapping each Funding Opportunity to the proper year
        this.setState({
          foData: fundingOpportunityData,
        });
        let fundingOpportunityYear = [];
        _.map(fundingOpportunityData, (o) => {
          fundingOpportunityYear[o.fundingOpportunityId] = o.fiscalYear;
        });
        this.setState({fundingOpportunityYear});

        _.each(fundingOpportunityData, (fo) => {
          filterOptions.fiscalYears.push({
            key: fo.fiscalYear,
            value: fo.fiscalYear,
            text: fo.fiscalYear,
            foId: fo.fundingOpportunityId,
          });
          filterOptions.programs.push({
            key: toStartCase(fo.programName),
            value: fo.programName,
            text: fo.programName,
            programId: fo.programId,
          });
          filterOptions.fundingOpportunities.push({
            key: toStartCase(fo.fundingOpportunityName),
            value: fo.fundingOpportunityName,
            text: fo.fundingOpportunityName,
            programId: fo.fundingOpportunityId,
            aplcnEndDate: fo.aplcnEndDate,
          });
        });

        _.each(_.keys(filterOptions), (key) => {
          filterOptions[key] = _.unionBy(filterOptions[key], 'key');
        });

        return filterOptions;
      });
  };

  createStatusFilterOptions = (_allGrants) => {
    const {retrievedFilters, retrievedSortOptions} = this.state;
    const statuses = _.uniq(_.map(_allGrants, (grant) => grant.status));
    const _statusOptions = _.map(statuses, (status) => ({
      key: status,
      value: status,
      text: this.convertText(status),
    }));
    _statusOptions.unshift(EMPTY_FILTER[0]);

    this.setState({filterOptions: {...this.state.filterOptions, status: _statusOptions}});

    if (_.toLower(_.get(retrievedFilters, 'entityType')) == 'grant') {
      this.setState({
        grantsChecked: true,
      });
    } else if (_.toLower(_.get(retrievedFilters, 'entityType')) == 'subApplication') {
      this.setState({
        projectsChecked: true,
      });
    }

    this.setState(
      {
        sortOptions: retrievedSortOptions,
      },
      () => this.doMultipleFilters(retrievedFilters)
    );
  };

  convertText = (strValue) => {
    return _.get(ASSOCIATED_ENTITY_STATUSES, strValue);
  };

  applySort = (grants) => {
    if (grants === undefined || _.isEmpty(grants)) return [];
    const {sortOptions} = this.state;
    let sortedGrants = [...grants];
    if (sortOptions.sortBy && sortOptions.sortDir) {
      sortedGrants = _.sortBy(grants, [sortOptions.sortBy, 'grantId']); // grantId is a tie breaker
      if (sortOptions.sortDir.toLowerCase() === 'desc') {
        sortedGrants = _.reverse(sortedGrants);
      }
    }
    return sortedGrants;
  };

  isUserOrgAOR = (permissions, orgId, roleId) => {
    if (_.isEmpty(permissions)) {
      return false;
    } else {
      return _.chain(permissions)
        .map((permission) => {
          let [entityTypeId, entityId, role] = permission.split(':');
          if (
            entityId == orgId &&
            entityTypeId == ENTITY_MAP.ORGANIZATION.code &&
            role == roleId
          ) {
            return true;
          }
        })
        .filter((value) => value !== undefined)
        .uniq()
        .value()[0];
    }
  };

  // First call
  fetchData = (entityId, organizationChanged = false) => {
    const {orgChanged, currentOrg, filters} = this.state;
    let orgId;
    if (entityId) {
      this.setState((prevState) => ({
        currentOrg: {
          ...prevState.currentOrg,
          entityId,
        },
      }));
      orgId = entityId;
    } else {
      orgId = currentOrg.entityId;
    }

    let grants = [];
    let closeoutReportStatusByGrantId = {};
    let subCloseoutReportStatusBySubGrantId = {};
    let orgProgramsForSelectedOrg = [];
    let foIds, programs, statuses;

    const permissionUtil = new PermissionsUtility(this.props.token);

    orgProgramsForSelectedOrg = !this.isUserOrgAOR(
      this.props.permissions,
      orgId,
      ROLE_MAP.ORGAOR.code
    )
      ? permissionUtil.getProgramForOrganization(orgId)
      : '';
    // If just a filter change, then perform client side sort/filtering
    if (orgChanged || organizationChanged) {
      const {token, permissions} = this.props;
      this.setState({
        orgChanged: false,
      });
      REST.workflow
        .getAllExternalEligibleTasks(
          token,
          ['grantId', 'awardAcceptanceDueDate'],
          _.isEmpty(permissions)
            ? {
                includeAssignedTasks: true,
              }
            : {
                includeAssignedTasks: true,
                candidateGroups: permissions,
              }
        )
        .then((res) => {
          if (res.status === 200) {
            return forceJsonResponse(res, MONO);
          }
        })
        .then((resJson) => this.setState({tasks: resJson}))
        .then(() => {
          this.props
            .getGrantByOrganization(
              this.props.token,
              orgId,
              filters,
              orgProgramsForSelectedOrg !== null ? orgProgramsForSelectedOrg : ''
            )
            .then((res) => {
              if (res.type === API_DYNAMIC_DATA_GRANT_BY_ORGANIZATION_GET_SUCCESS) {
                grants = res.payload;

                foIds = getUniqs(grants, 'fundingOpportunityId');
                _.pull(foIds, undefined, null);
                this.getApplicationExtensions(foIds).then((res) => {
                  if (res) {
                    this.setState({
                      foAppExtRes: res,
                    });
                  }
                });
                programs = _.uniq(_.map(grants, (grant) => grant.programId));

                this.setState({
                  error: false,
                });
                this.createFilterOptions(foIds, programs, statuses)
                  .then((filterOptions) => {
                    // Decorate grant records with fiscal year for sorting
                    const foToYear = _.reduce(
                      filterOptions.fiscalYears,
                      (result, option) => {
                        if (option.key) {
                          result[option.foId] = option.key;
                        }
                        return result;
                      },
                      {}
                    );
                    // Decorate grant records with Program Name
                    const programNames = _.reduce(
                      filterOptions.programs,
                      (result, program) => {
                        if (program.value) {
                          result[program.programId] = program.value;
                        }
                        return result;
                      },
                      {}
                    );
                    // Decorate grant records with FO Name and application End Date
                    const foData = _.reduce(
                      filterOptions.fundingOpportunities,
                      (result, fo) => {
                        if (fo.programId) {
                          result[fo.programId] = {
                            name: fo.value,
                            aplcnEndDate: fo.aplcnEndDate,
                          };
                        }
                        return result;
                      },
                      {}
                    );
                    const {tasks, fundingOpportunityYear} = this.state;
                    _.each(grants, (grant) => {
                      grant.programName = _.get(programNames, grant.programId);
                      grant.fiscalYr = _.get(
                        fundingOpportunityYear,
                        grant.fundingOpportunityId
                      );
                      this.getAmendments(grant, this.state.foData);
                      const fo = _.get(foData, grant.fundingOpportunityId, {});
                      grant.fundingOpportunityName = fo.name;
                      grant.aplcnEndDate = fo.aplcnEndDate;
                      // Add awardAcceptanceDueDate
                      const eligibleTask =
                        _.find(tasks, (task) => {
                          return (
                            task.grantId === grant.grantId &&
                            task.taskDefinitionKey === 'awardAcceptance'
                          );
                        }) || {};
                      grant.awardAcceptanceDueDate = eligibleTask.awardAcceptanceDueDate;
                    });
                    this.setState({
                      onlyGrants: this.applySort(grants),
                      grants: this.applySort(grants),
                      allGrants: grants,
                      filterOptions: filterOptions,
                    });
                  })
                  .then(() => {
                    this.getConfig(foIds, 'fo').then(() => {
                      this.setState({
                        orgChanged: true,
                      });
                    });
                  });
                if (this.props.toggles.includes('grantFilters')) {
                  this.setState({loading: true});
                  this.callFetchSubapplicationBasedUponToggle(
                    this.props.pageEntityType,
                    this.props.toggles,
                    currentOrg,
                    grants
                  );
                } else {
                  this.setState({
                    loading: false,
                  });
                }
              } else if (
                res.type === API_DYNAMIC_DATA_GRANT_BY_ORGANIZATION_GET_FAILURE
              ) {
                if (this.props.toggles.includes('grantFilters')) {
                  this.setState({loading: true});
                  this.callFetchSubapplicationBasedUponToggle(
                    this.props.pageEntityType,
                    this.props.toggles,
                    currentOrg,
                    grants
                  );
                } else {
                  this.setState({
                    loading: false,
                    orgChanged: false,
                    allGrants: [],
                  });
                }
              } else {
                // Organization does not have grants
                this.setState({
                  orgChanged: true,
                });
                if (this.props.toggles.includes('grantFilters')) {
                  this.setState({loading: true});
                  this.callFetchSubapplicationBasedUponToggle(
                    this.props.pageEntityType,
                    this.props.toggles,
                    currentOrg,
                    grants
                  );
                } else {
                  this.setState({
                    loading: false,
                  });
                }
              }
            });
        });
      /*
       * TODO: Revert code used to implement GMMGO-39048 once fundingOpportunity-####-closeoutReview toggles deployed
       * fundingOpp*-closoutSubmission toggles enabled, recipient should be able to revert only if closeoutReport status
       * is not submittedToFEMA, so need both grants.status and closeoutReport status passed to getGrantActions()
       * to determine whether or not user can "Restore grant to post-award phase".
       * Populating closeoutReportStatusByGrantId, saving to state, passing that property to <GrantsFilterResults>
       * component won't be necessary after fundingOpp*-closeoutReview is deployed.
       * See See GMMGO-39113
       */
      this.props
        .getDataByOrgIdByEntityType(this.props.token, orgId, 'closeoutReport')
        .then((res) => {
          if (res.type === DYNAMIC_DATA_GET_ORG_ENTITY_SUCCESS) {
            const closeoutReports = res.payload;
            _.forEach(closeoutReports, (closeoutReport) => {
              const grantId = _.get(closeoutReport, 'grantId', -1);
              const closeoutReportStatus = _.get(closeoutReport, 'status', undefined);
              closeoutReportStatusByGrantId[grantId] = closeoutReportStatus;
            });
            this.setState({closeoutReportStatusByGrantId});
          } else if (res.type === DYNAMIC_DATA_GET_ORG_ENTITY_FAILURE) {
            this.setState({closeoutReportStatusByGrantId: {}});
          }
        });

      this.props
        .getDataByOrgIdByEntityType(this.props.token, orgId, 'subCloseoutReport')
        .then((res) => {
          if (res.type === DYNAMIC_DATA_GET_ORG_ENTITY_SUCCESS) {
            const subCloseoutReports = res.payload;
            _.forEach(subCloseoutReports, (subCloseoutReport) => {
              const grantId = _.get(subCloseoutReport, 'grantId', -1);
              const subGrantId = _.get(subCloseoutReport, 'subGrantId', -1);
              const subCloseoutReportStatus = _.get(
                subCloseoutReport,
                'status',
                undefined
              );
              subCloseoutReportStatusBySubGrantId[subGrantId] = subCloseoutReportStatus;
            });
            this.setState({
              subCloseoutReportStatusBySubGrantId,
            });
          } else if (res.type === DYNAMIC_DATA_GET_ORG_ENTITY_FAILURE) {
            this.setState({
              subCloseoutReportStatusBySubGrantId: {},
            });
          }
        });
    } else {
      this.setState({loading: false, grants: this.applySort(this.state.grants)});
    }
  };

  callFetchSubapplicationBasedUponToggle = (
    pageEntityType,
    toggles,
    currentOrg,
    grants
  ) => {
    const {token} = this.props;

    if (_.includes(toggles, 'manageTeamOrgSubOrg')) {
      if (
        currentOrg.entityRelationshipType !==
        parseInt(ORG_REL_TYPE_MAP.NOT_PARENT_ORG_OR_SUBORG.code)
      ) {
        const permissionUtil = new PermissionsUtility(this.props.token);
        let parentList = permissionUtil.getParentOrgIdListForSubOrg(currentOrg.entityId);
        let isSelectedOrgForEntityOneAndFive = permissionUtil.isCurrentIdExistForEntityOneAndFive(
          currentOrg.entityId,
          this.props.token
        );
        //entity 1 & 5
        if (isSelectedOrgForEntityOneAndFive) {
          if (currentOrg.canHaveSuborganizations) {
            if (!_.isEmpty(parentList) && _.includes(parentList, currentOrg.entityId)) {
              this.fetchSubApplicationDataV2(
                null,
                parentList,
                grants,
                'getSubAppsBySubOrgIdAndOrgIdListAndByCategoryIdBothSelfAndApplicant',
                'getSubAppsBySubOrgIdAndOrgIdListAndByProgramIdBothSelfAndApplicant',
                'getSubGrantsBySubOrgIdAndOrgIdListBothSelfAndApplicant'
              );
            } else {
              this.fetchSubApplicationDataV2(
                'self',
                currentOrg.entityId,
                grants,
                'getSubAppsByOrgIdAndByCategoryId',
                'getSubAppsByOrgIdAndByProgramId',
                'getSubGrantsByOrgId'
              );
            }
          } else if (
            currentOrg.entityRelationshipType == ORG_REL_TYPE_MAP.SUBORGANZATION.code
          ) {
            this.fetchSubApplicationDataV2(
              'applicant',
              parentList,
              grants,
              'getSubAppsBySubOrgIdAndByCategoryId',
              'getSubAppsBySubOrgIdAndByProgramId',
              'getSubGrantsBySubOrgId'
            );
          } else {
            this.setState({
              allGrants: [],
              loading: false,
            });
          }
        }
        //entity 6 only
        else {
          if (currentOrg.canHaveSuborganizations) {
            // entity 6 and if self parent then get the self subapplications
            if (
              !_.isEmpty(parentList) &&
              parentList.length === 1 &&
              _.includes(parentList, currentOrg.entityId)
            ) {
              this.fetchSubApplicationDataV2(
                'self',
                parentList,
                grants,
                'getSubAppsBySubOrgIdAndOrgIdListAndByCategoryId',
                'getSubAppsBySubOrgIdAndOrgIdListAndByProgramId',
                'getSubGrantsBySubOrgIdAndOrgIdList'
              );
            }
            // entity 6 with multiple parents get all the subapplications for self and also applicant
            else {
              this.fetchSubApplicationDataV2(
                null,
                parentList,
                grants,
                'getSubAppsBySubOrgIdAndOrgIdListAndByCategoryIdBothSelfAndApplicant',
                'getSubAppsBySubOrgIdAndOrgIdListAndByProgramIdBothSelfAndApplicant',
                'getSubGrantsBySubOrgIdAndOrgIdListBothSelfAndApplicant'
              );
            }
          } else {
            this.fetchSubApplicationDataV2(
              'applicant',
              parentList,
              grants,
              'getSubAppsBySubOrgIdAndOrgIdListAndByCategoryId',
              'getSubAppsBySubOrgIdAndOrgIdListAndByProgramId',
              'getSubGrantsBySubOrgIdAndOrgIdList'
            );
          }
        }
      } else {
        //ORG_REL_TYPE_MAP.NOT_PARENT_ORG_OR_SUBORG.code is the AFG, there should be no subapplication search call
        this.setState({
          loading: false,
          allGrants: [],
        });
      }
    } else {
      this.fetchSubApplicationData('self', grants);
    }
  };
  // Second call
  fetchSubApplicationData = (submitted, allGrants) => {
    const {orgChanged, currentOrg} = this.state;
    const orgId = currentOrg.entityId;
    let programCategoryIds = [];
    let eligibleProgramIds = [];
    let subOrgId;
    const {token} = this.props;
    if (orgChanged) {
      this.setState({
        orgChanged: false,
        programCategoryIds: [],
        grants: allGrants,
        programId: {},
        allGrants: allGrants,
      });

      REST.ref
        .getTypesByItemCodes(this.props.token)
        .then((res) => {
          forceJsonResponse(res, FLUX);
        })
        .then((itemData) => {
          this.setState({
            refItems: itemData,
          });
        })
        .then((res) => {
          this.props
            .getOrgPrograms(this.props.token, orgId)
            .then((res) => {
              const programs = res.payload;
              let ids = _.uniq(
                _.map(programs, (program) => {
                  return program.programId;
                })
              );

              this.setState({programId: ids});
            })
            .then((res) => {
              let params = Array.from(this.state.programId).toString();
              this.props.getProgramInfo(this.props.token, params).then((resp) => {
                if (resp) {
                  let programs = resp.payload;
                  programs = _.orderBy(programs, ['programId'], ['asc']);
                  _.map(programs, (program) => {
                    if (program.subapplicationFlag === true) {
                      eligibleProgramIds.push(program.programId);
                      programCategoryIds.push(program.programCategoryId);
                      this.setState({
                        programCategoryIds: _.uniq(programCategoryIds),
                      });
                    }
                  });
                  if (this.state.programCategoryIds.length > 0) {
                    try {
                      const response = REST.search
                        .getSubAppsByOrgIdAndByCategoryId(
                          this.props.token,
                          orgId,
                          null,
                          null,
                          this.state.programCategoryIds,
                          submitted
                        )
                        .then((res) => {
                          if (res.status === 200) {
                            forceJsonResponse(res, MONO)
                              .then((resJson) => {
                                var items = _.union(resJson.items, allGrants);

                                // At this point allGrants has all
                                this.setState({
                                  searching: SEARCH_OPTIONS.SUCCESS,
                                  grants: _.cloneDeep(items),
                                  projects: _.cloneDeep(resJson.items),
                                  allGrants: _.cloneDeep(items),
                                });
                                // At this point 'allGrants' has both subapplications and grants combined

                                this.createStatusFilterOptions(allGrants);
                              })
                              .then((res) => {
                                subOrgId = _.uniq(
                                  _.map(
                                    this.state.grants,
                                    (grant) => grant.subOrganizationId
                                  )
                                );
                                let subOrganizationsDetails = [];
                                this.props
                                  .organizations(subOrgId, this.props.token)
                                  .then((res) => {
                                    if (res.type === API_ORGS_LIST_GET_BY_ID_SUCCESS) {
                                      res.payload.forEach((result) => {
                                        subOrganizationsDetails.push({
                                          entityId: result.organizationId,
                                          displayName: result.displayName,
                                        });
                                      });
                                      this.setState({
                                        subOrganizationsDetails: subOrganizationsDetails,
                                      });
                                    }
                                  })
                                  .then((res) => {
                                    this.getConfig(
                                      this.state.programCategoryIds,
                                      'pc'
                                    ).then((res) => {
                                      if (res) {
                                        this.setState({
                                          loading: false,
                                        });
                                      }
                                    });
                                  });
                              });
                          } else if (res && (res.status === 401 || res.status === 404)) {
                            // Organization does not have grants
                            this.setState({
                              grants: [],
                              allGrants: [],
                              loading: false,
                            });
                          }
                        });
                    } catch (error) {
                      this.setState({
                        searching: SEARCH_OPTIONS.ERROR,
                        data: [],
                        loading: false,
                      });
                    }
                  } else {
                    this.setState({
                      loading: false,
                    });
                  }
                }
              });
            });
        });
    } else {
      this.doFilter();
    }
  };

  subAppProgramHandler = (
    res,
    orgId,
    organizationId,
    parentOrgIds,
    submitted,
    searchByCategoryCall,
    searchByProgramCall,
    subGrantCall,
    allGrants
  ) => {
    let subOrgId;
    if (!_.isEmpty(res)) {
      this.setState(
        {
          eligibleProgramIds: res.eligibleProgramIds,
          programCategoryIds: _.uniq(res.programCategoryIds),
        },
        () => {
          if (this.state.programCategoryIds.length > 0) {
            try {
              let promises = [];
              _.forEach(this.state.eligibleProgramIds, (programId) => {
                promises.push(
                  REST.search[searchByProgramCall](
                    this.props.token,
                    organizationId,
                    orgId,
                    parentOrgIds,
                    programId,
                    submitted
                  )
                );
              });
              _.forEach(this.state.programCategoryIds, (categoryId) => {
                promises.push(
                  REST.search[searchByCategoryCall](
                    this.props.token,
                    organizationId,
                    orgId,
                    parentOrgIds,
                    categoryId,
                    submitted
                  )
                );
              });
              const response = Promise.all(promises)
                .then((results) => {
                  const successResults = _.filter(
                    results,
                    (result) => result.status === 200
                  );
                  return Promise.all(successResults.map((r) => r.json()));
                })
                .then((results) => {
                  if (!_.isEmpty(results)) {
                    const resItems = _.flatMap(results, (result) => result.items);
                    const subGrantResponse = REST.search[subGrantCall](
                      this.props.token,
                      organizationId,
                      orgId,
                      parentOrgIds,
                      submitted
                    )
                      .then((subGrantRes) => {
                        if (subGrantRes.status === 200) {
                          return subGrantRes.json();
                        } else {
                          return Promise.resolve({items: []});
                        }
                      })
                      .then((subGrantJson) => {
                        // replace subapp with subgrant if it exists
                        const subapps = subApplicationsToSubGrantsFilter(
                          resItems,
                          subGrantJson.items
                        );
                        let formatedItems = _.union(subapps, allGrants);

                        // At this point allGrants has all
                        this.setState(
                          {
                            searching: SEARCH_OPTIONS.SUCCESS,
                            grants: formatedItems,
                            projects: JSON.parse(JSON.stringify(resItems)),
                            allGrants: formatedItems,
                          },
                          () => {
                            let grantConfigItems = [];
                            _.forEach(this.state.projects, (subApp) => {
                              if (subApp.categoryId == '406') {
                                grantConfigItems.push({
                                  foId: 406,
                                  entityType: 'pc',
                                  configName: 'grantsConfig',
                                });
                              } else {
                                grantConfigItems.push({
                                  foId: subApp.fundingOpportunityId,
                                  entityType: 'fo',
                                  configName: 'subGrantConfig',
                                });
                              }
                            });
                            let confItems = _.uniqBy(grantConfigItems, 'foId');
                            this.createStatusFilterOptions(formatedItems);
                            subOrgId = _.uniq(
                              _.map(this.state.grants, (grant) => grant.subOrganizationId)
                            );
                            let subOrganizationsDetails = [];
                            if (!_.values(subOrgId).every(_.isUndefined)) {
                              this.props
                                .organizations(subOrgId, this.props.token)
                                .then((res) => {
                                  if (res.type === API_ORGS_LIST_GET_BY_ID_SUCCESS) {
                                    res.payload.forEach((result) => {
                                      subOrganizationsDetails.push({
                                        entityId: result.organizationId,
                                        displayName: result.displayName,
                                      });
                                    });
                                    this.setState(
                                      {
                                        subOrganizationsDetails: subOrganizationsDetails,
                                      },
                                      () => {
                                        this._getConfigByCategoryId(confItems).then(
                                          (res) => {
                                            if (res) {
                                              this.setState({
                                                loading: false,
                                              });
                                            }
                                          }
                                        );
                                      }
                                    );
                                  } else {
                                    this.setState({
                                      loading: false,
                                    });
                                  }
                                });
                            } else {
                              this.setState({
                                loading: false,
                              });
                            }
                          }
                        );
                        this.doMultipleFilters(this.state.retrievedFilters);
                      });
                  } else {
                    this.setState({
                      grants: [],
                      allGrants: [],
                      loading: false,
                    });
                  }
                });
            } catch (error) {
              this.setState({
                searching: SEARCH_OPTIONS.ERROR,
                data: [],
                loading: false,
              });
            }
          } else {
            this.setState({
              loading: false,
            });
          }
        }
      );
    }
  };

  fetchSubApplicationDataV2 = (
    submitted,
    parentOrgIds,
    allGrants,
    searchByCategoryCall,
    searchByProgramCall,
    subGrantCall
  ) => {
    const {orgChanged, currentOrg} = this.state;
    let organizationId;
    if (parentOrgIds) {
      const isArray = _.isArray(parentOrgIds);
      organizationId =
        isArray && parentOrgIds.length == 2
          ? parentOrgIds[1]
          : isArray
          ? parentOrgIds[0]
          : parentOrgIds;
    }

    const orgId = currentOrg.entityId;

    if (!orgChanged) {
      this.setState({
        orgChanged: false,
        programCategoryIds: [],
        grants: allGrants,
        programId: {},
        allGrants: allGrants,
      });

      REST.ref
        .getTypesByItemCodes(this.props.token)
        .then((response) => {
          return forceJsonResponse(response, FLUX);
        })
        .then((itemData) => {
          this.setState({
            refItems: itemData,
          });
        })
        .then((res) => {
          const permissionUtil = new PermissionsUtility(this.props.token);
          if (organizationId != orgId) {
            permissionUtil
              .getSubOrgProgramIdAndCategoryIdByOrgId(
                this.props.token,
                organizationId,
                orgId
              )
              .then((res) => {
                this.subAppProgramHandler(
                  res,
                  orgId,
                  organizationId,
                  parentOrgIds,
                  submitted,
                  searchByCategoryCall,
                  searchByProgramCall,
                  subGrantCall,
                  allGrants
                );
              });
          } else {
            permissionUtil
              .getProgramIdAndCategoryIdByOrgId(this.props.token, orgId)
              .then((res) => {
                this.subAppProgramHandler(
                  res,
                  orgId,
                  orgId,
                  parentOrgIds,
                  submitted,
                  searchByCategoryCall,
                  searchByProgramCall,
                  subGrantCall,
                  allGrants
                );
              });
          }
        });
    } else {
      this.doFilter();
      this.setState({
        loading: false,
      });
    }
  };

  doFilter = () => {
    // Client side filtering
    const {grantsChecked, projectsChecked, filters, filterKey, filterValue} = this.state;

    // if both Grants and Project checkbox are not checked remove key from filter.
    if (grantsChecked === false && projectsChecked === false) {
      let newFilters = _.omit(filters, ['entityType']);
      this.setState(
        {
          filters: newFilters,
        },
        () => {
          this.doMultipleFilters(newFilters);
        }
      );
    } else {
      if (filters.entityType === 'grant') {
        this.setState({projectsChecked: false, grantsChecked: true});
      } else {
        this.setState({projectsChecked: true, grantsChecked: false});
      }

      this.doMultipleFilters(filters);
    }
  };

  doMultipleFilters = (filters) => {
    let {allGrants} = this.state;
    let filteredGrants = this.applySort(allGrants);
    const filterFieldToOmit = ['userId'];
    const nonEmptyFilters = _.filter(filters, (v) => v).length;
    if (nonEmptyFilters > 0) {
      _.forEach(filters, (v, k) => {
        filteredGrants = _.filter(filteredGrants, (item) => {
          if (!v || _.includes(filterFieldToOmit, k)) return item;
          if (_.isEqualWith(_.toLower(item[k]), _.toLower(v))) {
            return item;
          }
        });
        this.setState({
          grants: filteredGrants,
          filters: filters,
          loading: false,
          error: false,
        });
      });
    } else {
      this.setState({
        grants: filteredGrants,
        filters: filters,
        loading: false,
        error: false,
      });
    }
  };

  setFilter = (name, value) => {
    this.setState({loading: true}, () => {
      if (name === 'isGrant') {
        name = 'entityType';
        let _value = 'grant';
        this.setState(
          (prevState) => ({
            grantsChecked: value,
          }),
          () => {
            if (value) {
              this.setFilterState(name, _value);
            } else {
              this.setFilterState(name, '');
            }
          }
        );
      } else if (name === 'isSubApp') {
        name = 'entityType';
        let _value = 'subApplication';

        this.setState(
          (prevState) => ({
            projectsChecked: value,
          }),
          () => {
            if (value) {
              this.setFilterState(name, _value);
            } else {
              this.setFilterState(name, '');
            }
          }
        );
      } else {
        this.setFilterState(name, value);
      }
    });
  };

  setFilterState = (name, value) => {
    // gets called after the state projectsChecked is updated
    const {retrievedFilters} = this.state;
    const newRetrievedFilters = {
      ...retrievedFilters,
      [name]: value,
      userId: this.props.id,
    };
    localStorage.setItem('grantsFilters', JSON.stringify(newRetrievedFilters));
    this.setState(
      (prevState) => ({
        filters: {
          ...prevState.filters,
          [name]: value,
        },
        filterKey: name,
        filterValue: value,
        retrievedFilters: newRetrievedFilters,
      }),
      () => {
        this.doFilter();
      }
    );
  };

  renderOrgDropdown = () => {
    const {allOrgs, currentOrg} = this.state;
    const {toggles} = this.props;

    const dunsToUEIToggle = _.includes(toggles, 'dunsToUEI');
    const ueiEftFormat =
      currentOrg.uei +
      (!_.isEmpty(_.trim(currentOrg.eft)) ? '-' + _.trim(currentOrg.eft) : '');
    const ueiEft = currentOrg.uei ? ' ' + ueiEftFormat : '';

    let sortedOrgs = _.sortBy(allOrgs, 'displayName');

    if (allOrgs && allOrgs.length === 1) {
      return dunsToUEIToggle ? (
        <Grid.Column>
          <h4>{currentOrg.displayName + ueiEft || sortedOrgs[0].displayName}</h4>
        </Grid.Column>
      ) : (
        <Grid.Column>
          <h4>{currentOrg.displayName || sortedOrgs[0].displayName}</h4>
        </Grid.Column>
      );
    } else if (allOrgs && allOrgs.length > 1) {
      return (
        <React.Fragment>
          <Grid.Column key="selectOrgFormColumn" width={5} className="org-select-label">
            <h5>
              <label htmlFor="orgSelect">Select an organization</label>
            </h5>
            <Form>
              <Select
                key="selectOrgForm"
                placeholder=""
                search
                selection
                title="Select an organization"
                id={'orgSelect'}
                name={'orgSelect'}
                value={currentOrg.entityId}
                handleChange={this.handleOrgChange}
                className={'select-organization'}
                options={_.map(sortedOrgs, (entry, index) => {
                  return dunsToUEIToggle
                    ? {
                        value: entry.entityId,
                        text:
                          entry.displayName +
                          (entry.uei
                            ? !_.isEmpty(_.trim(entry.eft))
                              ? ' ' + entry.uei + '-' + entry.eft
                              : ' ' + entry.uei
                            : ''),
                      }
                    : {
                        value: entry.entityId,
                        text: entry.displayName,
                      };
                })}
              />
            </Form>
          </Grid.Column>
        </React.Fragment>
      );
    }
  };

  handleSortChange = (name, value) => {
    let sortOptions = _.get(this.state, 'sortOptions', {});
    sortOptions[name] = value;
    sortOptions.userId = this.props.id;
    this.setState({loading: true, sortOptions: sortOptions}, () => {
      this.fetchData();
    });
    localStorage.setItem('grantsSort', JSON.stringify(sortOptions));
  };

  renderFilter = () => {
    const {
      filterOptions,
      filters,
      sortOptions,
      grantsChecked,
      projectsChecked,
    } = this.state;

    return (
      <Grid.Column key="gridFiltersColumn">
        <Form key="grantsFilterForm">
          <h3>Search</h3>
          <TextBoxField
            key="grantIdSearchTextBox"
            title="Search by grant ID"
            name="grantId"
            label="Grant ID"
            id="searchString"
            value={filters.grantId || ''}
            handleChange={(e) => this.setFilter(e.target.name, e.target.value)}
          />
          <Toggle toggle="grantFilters">
            <h3>Show</h3>
            <Checkbox
              key="isGrant"
              label="My grants"
              id="isGrant"
              checked={grantsChecked || filters.entityType === 'grant'}
              handleChange={(id, value) => {
                this.setFilter('isGrant', value);
              }}
            />
            <Checkbox
              key="isSubApp"
              label="My subapplication projects"
              id="isSubApp"
              checked={projectsChecked || filters.entityType === 'subApplication'}
              handleChange={(id, value) => {
                this.setFilter('isSubApp', value);
              }}
            />
          </Toggle>
          <h3>Filters</h3>
          <InlineSelect
            key="grantProgramNameSelect"
            id="program"
            label="Grant program"
            labeled="true"
            search
            selection
            title="Filter by grant program"
            name="programName"
            value={filters.programName || ''}
            handleChange={(e) => this.setFilter(e.target.name, e.target.value)}
            options={filterOptions ? filterOptions.programs : []}
          />
          <InlineSelect
            key="grantFiscalYrSelect"
            id="fiscalYr"
            label="Fiscal Year"
            labeled="true"
            search
            selection
            title="Filter by fiscal year"
            name="fiscalYr"
            value={filters.fiscalYr || ''}
            handleChange={(e) => this.setFilter(e.target.name, e.target.value)}
            options={filterOptions ? filterOptions.fiscalYears : []}
          />
          <Toggle toggle="grantFilters">
            <InlineSelect
              key="grantStatusSelect"
              id="grantStatus"
              label="Status"
              labeled="true"
              search
              selection
              title="Filter by Grant Status"
              name="status"
              value={filters.status || ''}
              handleChange={(e) => this.setFilter(e.target.name, e.target.value)}
              options={filterOptions ? filterOptions.status : []}
            />
          </Toggle>
          <h3>Sort</h3>
          <InlineSelect
            key="grantSortBySelect"
            search
            selection
            title="Sort"
            name="sortBy"
            id="sortBy"
            label="Sort by"
            handleChange={(e) => {
              this.handleSortChange(e.target.name, e.target.value);
            }}
            value={sortOptions.sortBy}
            options={[
              ...EMPTY_FILTER,
              {key: 'fiscalYr', value: 'fiscalYr', text: 'Fiscal Year'},
              {
                key: 'grantId',
                value: 'grantId',
                text: 'Grant Id',
              },
            ]}
          />
          <Form.Field>
            <RadioField
              key="grantSortDirRadio"
              name="sortDir"
              value={sortOptions.sortDir}
              handleChange={(e) => {
                this.handleSortChange(e.target.name, e.target.value);
              }}
              options={[
                {label: 'Ascending (A-Z)', value: 'asc'},
                {label: 'Descending (Z-A)', value: 'desc'},
              ]}
            />
          </Form.Field>
        </Form>
      </Grid.Column>
    );
  };

  renderGrants = () => {
    const {
      grants,
      closeoutReportStatusByGrantId,
      subCloseoutReportStatusBySubGrantId,
      allGrants,
      loading,
    } = this.state;
    return (
      <Grid.Column width={12}>
        {allGrants && allGrants.length > 0 ? (
          <GrantsFilterResults
            key="grantsFilterResults"
            data={grants}
            closeoutReportStatusByGrantId={closeoutReportStatusByGrantId}
            grantAppExt={this.state.grantAppExtensions}
            grantConfigs={this.state.grantConfigs}
            subGrantConfigs={this.state.subGrantConfigs}
            refItems={this.state.refItems}
            subOrganizationsDetails={this.state.subOrganizationsDetails}
            grantWriterEntityIds={this.state.grantWriterEntityIds}
            subCloseoutReportStatusBySubGrantId={subCloseoutReportStatusBySubGrantId}
            currentOrg={this.state.currentOrg}
            token={this.props.token}
            pageEntityType={'grant'}
            foData={this.state.foData}
            amendments={this.state.amendments}
          />
        ) : !loading && allGrants && allGrants.length === 0 ? (
          <Alert header="No Grants Found" type="info">
            <p>There are no grants associated with your organization.</p>
          </Alert>
        ) : (
          // Added a second load to prevent a blank screen from appearing while page reloads.
          <Grid.Column width={12}>
            <Loader inline="centered" active content="Loading" />
          </Grid.Column>
        )}
      </Grid.Column>
    );
  };

  render() {
    const {loading, error, noOrgsFound} = this.state;
    const sortReorder = _.includes(this.props.toggles, 'disasterSiteNav');

    if (error) return <Error />;

    return (
      <Main>
        <Container fluid>
          {noOrgsFound ? (
            <Grid
              key="noOrgGrid"
              doubling
              stackable
              reversed="mobile"
              padded="vertically"
            >
              <Grid.Row>
                <Grid.Column>
                  <Segment basic textAlign="center">
                    <h2>You must first belong to an organization to see your grants.</h2>
                  </Segment>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          ) : (
            <Grid
              key="orgGrantsGrid"
              doubling
              stackable
              reversed="mobile"
              padded="vertically"
            >
              <Grid.Row key="orgDropDown">{this.renderOrgDropdown()}</Grid.Row>
              <Grid.Row key="orgGrants">
                {sortReorder && (
                  <Grid.Column width={4}>{this.renderFilter()}</Grid.Column>
                )}
                {!sortReorder && (
                  <Grid.Column width={4}>{this.renderFilter()}</Grid.Column>
                )}
                {loading ? (
                  <Grid.Column width={12}>
                    <Loader inline="centered" active content="Loading" />
                  </Grid.Column>
                ) : (
                  this.renderGrants()
                )}
              </Grid.Row>
            </Grid>
          )}
        </Container>
      </Main>
    );
  }
}

export const mapDispatchToProps = (dispatch) => {
  return {
    init: (initState) => dispatch(DynamicComponentActions.initWithState(initState)),
    getGrantByOrganization: (token, orgId, filters, orgPrograms) => {
      const action = ApiActions.dynamicData.getGrantByOrganizationByProgramIds(
        token,
        orgId,
        filters,
        orgPrograms
      );
      const response = dispatch(action);
      return response;
    },
    getOrgPrograms: (token, orgId) => {
      const action = ApiActions.organizationRelationship.getAllOrganizationProgramsByOrgId(
        token,
        orgId
      );
      const response = dispatch(action);
      return response;
    },
    getProgramInfo: (token, params) => {
      const action = ApiActions.program.getProgramList(token, params);
      const response = dispatch(action);
      return response;
    },
    getDataByOrgIdByEntityType: (token, orgId, entityType) => {
      const action = ApiActions.dynamicData.getDataByOrgIdByEntityType(
        token,
        orgId,
        entityType
      );
      const response = dispatch(action);
      return response;
    },
    getOrganizationById: (token, orgId) => {
      const action = ApiActions.organization.getOrganizationById(token, orgId);
      const response = dispatch(action);
      return response;
    },
    getOrganizations: (token) => {
      const action = ApiActions.organization.getOrganizationsByCurrentUser(token);
      const response = dispatch(action);
      return response;
    },
    organizations: (orgIds, token) => {
      const action = ApiActions.organization.getOrganizationsListById(token, orgIds);
      const response = dispatch(action);
      return response;
    },
    getConfig: (token, entityType, entityId, configType, configId) => {
      let action = ApiActions.config.getConfig(
        token,
        entityType,
        entityId,
        configType,
        configId
      );
      const response = dispatch(action);
      return response;
    },
  };
};

export const mapStateToProps = (state) => {
  return {
    id: state.auth.userId,
    token: state.auth.token,
    permissions: state.auth.permissions,
    toggles: state.toggles.toggles,
    auth: state.auth,
    profile: state.profile,
  };
};

const Grants = connect(mapStateToProps, mapDispatchToProps)(_Grants);

export default Grants;
